import React from 'react'

import { Icon } from '@zet/design-system/index'
import { Stack, XStack } from '@zet/design-system/layout'
import { B4, SH3 } from '@zet/design-system/typography'

import { cardType } from '../../utils/constants'

interface CreditScoreLevelCardType {
  level?: 'Excellent' | 'High' | 'Medium' | 'Low'
  bureau: 'EXPERIAN' | 'CRIF'
}

const CreditScoreLevelCard = ({ level, bureau }: CreditScoreLevelCardType) => {
  return (
    <Stack>
      {!!level && (
        <XStack className="mb-2 items-center justify-between px-2">
          <XStack
            className={`items-center justify-center space-x-2 rounded-md px-3 py-2 ${
              cardType(level, bureau).bgColor
            }`}
          >
            <Icon type={cardType(level, bureau).Icon} size={20} />
            <B4 className="ml-[2]">{level}</B4>
          </XStack>
          <SH3 className="text-grays-80">{cardType(level, bureau).score}</SH3>
        </XStack>
      )}
    </Stack>
  )
}

export default CreditScoreLevelCard
